var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.params.node.group)?_c('span',[_vm._v(_vm._s(_vm.params.value))]):(_vm.mValue)?_c('div',{style:(_vm.style)}):_c('span',[_vm._v("未设置")])}
var staticRenderFns = []

export { render, staticRenderFns }